import React, {FC} from 'react'

export const DataIcon: FC = () => (
  <svg width="45" height="45" viewBox="0 0 45 45">
    <defs>
      <circle id="0yaiv4mq4a" cx="22.5" cy="22.5" r="22.5" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-520 -670) translate(50 170) translate(420 240) translate(50 260)">
        <mask id="h3e5c5yjeb" fill="#fff">
          <use xlinkHref="#0yaiv4mq4a" />
        </mask>
        <use fill="#424C65" fillRule="nonzero" xlinkHref="#0yaiv4mq4a" />
        <rect
          width="25"
          height="32"
          x="5"
          y="20"
          fill="#426FE2"
          fillRule="nonzero"
          mask="url(#h3e5c5yjeb)"
          rx="1"
        />
        <rect
          width="25"
          height="32"
          x="10"
          y="13"
          fill="#78A7FF"
          mask="url(#h3e5c5yjeb)"
          rx="1"
        />
        <rect width="15" height="1.5" x="15" y="33" fill="#4466C5" rx=".5" />
        <rect width="15" height="1.5" x="15" y="36.25" fill="#4466C5" rx=".5" />
        <rect width="9" height="1.5" x="18" y="39.5" fill="#4466C5" rx=".5" />
        <path
          fill="#FFF"
          d="M22.5 24c2.523 0 4.5 1.538 4.5 3.5 0 .783-.616 1.425-1.402 1.494l-.14.006h-5.915C18.69 29 18 28.329 18 27.5c0-1.962 1.977-3.5 4.5-3.5zm0-7c1.379 0 2.5 1.122 2.5 2.5 0 1.379-1.121 3.5-2.5 3.5S20 20.88 20 19.5c0-1.378 1.121-2.5 2.5-2.5z"
        />
        <path
          fill="#5B88FE"
          d="M13 13h2v3.5c0 .276-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5V13zM28 13h2v3.5c0 .276-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5V13z"
        />
        <rect width="2" height="4" x="14" y="12" fill="#FFF" rx=".5" />
        <rect width="2" height="4" x="29" y="12" fill="#FFF" rx=".5" />
      </g>
    </g>
  </svg>
)
